import { useCallback, useRef } from "react";

interface UseUploadAgainOptions {
    addMediaItems: (files: File[]) => Promise<void>;
    clearUploadLimitError?: () => void;
}

export const useUploadAgain = ({ addMediaItems, clearUploadLimitError }: UseUploadAgainOptions) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleUploadAgain = useCallback(() => {
        clearUploadLimitError?.();
        fileInputRef.current?.click();
    }, [clearUploadLimitError]);

    const handleFileSelected = useCallback(
        async (e: React.ChangeEvent<HTMLInputElement>) => {
            const files = Array.from(e.target.files || []);
            if (files.length > 0) {
                await addMediaItems(files);
            }
            // Reset the input value so the same file can be selected again
            e.target.value = "";
        },
        [addMediaItems]
    );

    return { fileInputRef, handleUploadAgain, handleFileSelected };
};
